// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz {
  background-color: white;
  width: 50%;
  position: absolute;
  top: 25%;
  left: 25%;
  padding: 20px;
  text-align: left;
  max-height: 500px;
  overflow-y: auto;
}

  .components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz h1 {
    font-weight: 600;
    font-size: 20px;
  }

  .components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz p {
    margin-left: 10px;
  }

  .components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz .components-EditBookingTravelersModal-styles___checkboxContainer--KNq7W {
    margin: 0px 0px 10px 10px;
  }

  .components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz .components-EditBookingTravelersModal-styles___buttonContainer--z7Loj {
    display: flex;
    justify-content: space-between;
  }
`, "",{"version":3,"sources":["webpack://./components/EditBookingTravelersModal/styles.pcss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAmBlB;;EAjBE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC","sourcesContent":[".editBookingTravelersModal {\n  background-color: white;\n  width: 50%;\n  position: absolute;\n  top: 25%;\n  left: 25%;\n  padding: 20px;\n  text-align: left;\n  max-height: 500px;\n  overflow-y: auto;\n\n  h1 {\n    font-weight: 600;\n    font-size: 20px;\n  }\n\n  p {\n    margin-left: 10px;\n  }\n\n  .checkboxContainer {\n    margin: 0px 0px 10px 10px;\n  }\n\n  .buttonContainer {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editBookingTravelersModal": `components-EditBookingTravelersModal-styles___editBookingTravelersModal--m8HKz`,
	"checkboxContainer": `components-EditBookingTravelersModal-styles___checkboxContainer--KNq7W`,
	"buttonContainer": `components-EditBookingTravelersModal-styles___buttonContainer--z7Loj`
};
module.exports = ___CSS_LOADER_EXPORT___;
